var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"10","height":"15","viewBox":"0 0 10 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.86597 9.73759C9.86597 8.58289 9.86597 5.69614 7.86597 4.54144L-7.53403e-05 -2.28882e-05V14.2791L7.86597 9.73759Z","fill":"#101B31"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }